module.exports = __webpack_public_path__ + "static/media/feature-talent-profile@3x.d544919d.png";